import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PageEndpointEnum } from "../../../enums/endpoints";
import { MobileSelectWrapper } from "./style";
import { Select } from "../Select";
import { AuthContext } from "../../../context/AuthContext";
import { hasPageAccess } from "../../../constants/permissions";

export function MobileDirectory() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { userEmail } = useContext(AuthContext);

  const allOptions = [
    {
      label: "Dashboard",
      isActive: pathname === "/",
      onClick: () => navigate("/"),
      page: PageEndpointEnum.DASHBOARD,
    },
    {
      label: "Withdrawals",
      isActive: pathname === PageEndpointEnum.WITHDRAW,
      onClick: () => navigate(PageEndpointEnum.WITHDRAW),
      page: PageEndpointEnum.WITHDRAW,
    },
    {
      label: "Transactions",
      isActive: pathname === PageEndpointEnum.TX,
      onClick: () => navigate(PageEndpointEnum.TX),
      page: PageEndpointEnum.TX,
    },
    {
      label: "Security",
      isActive: pathname === PageEndpointEnum.SECURITY,
      onClick: () => navigate(PageEndpointEnum.SECURITY),
      page: PageEndpointEnum.SECURITY,
    },
    {
      label: "Ondo",
      isActive: pathname === PageEndpointEnum.ONDO,
      onClick: () => navigate(PageEndpointEnum.ONDO),
      page: PageEndpointEnum.ONDO,
    },
    {
      label: "MM Monitoring",
      isActive: pathname === PageEndpointEnum.MM_MONITORING,
      onClick: () => navigate(PageEndpointEnum.MM_MONITORING),
      page: PageEndpointEnum.MM_MONITORING,
    },
    {
      label: "MM Control Panel",
      isActive: pathname === PageEndpointEnum.MM_CONTROL_PANEL,
      onClick: () => navigate(PageEndpointEnum.MM_CONTROL_PANEL),
      page: PageEndpointEnum.MM_CONTROL_PANEL,
    },
  ];

  // Filter options based on permissions
  const filteredOptions = allOptions.filter((option) =>
    hasPageAccess(userEmail, option.page)
  );

  return (
    <MobileSelectWrapper>
      <Select
        options={filteredOptions.map(({ label, isActive, onClick }) => ({
          label,
          isActive,
          onClick,
        }))}
      />
    </MobileSelectWrapper>
  );
}
